<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane v-for="item in ywList" :key="item.ywcode" :label="item.ywmc" :name="item.ywcode">
        <el-row style="margin-top: 10px" v-if="activeName">
          <el-col :span="12" v-for="(rwlx,index) in rwlxList" :key="index" style="text-align: center">
            <span>{{rwlx.dictName}}</span>
            <div style="margin: 10px" v-for="(mrrwsz,index) in mrrwszList" :key="index" v-if="rwlx.dictCode==mrrwsz.rwlx">
              <label style="width: 80px;display: inline-block;text-align: right">{{ mrrwsz.mc }}：</label>
              <div style="display: inline-block">
                <el-input v-model="mrrwsz.zhi" type="Number" min="0" placeholder="请输入" clearable style="width: 200px;margin-bottom: 10px;"></el-input>
                <span>{{ mrrwsz.dw }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="24" style="text-align: center">
            <el-button type="primary" @click="mrrwszSave">保存设置</el-button>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    
	</div>
</template>

<script>
export default {
	name: 'mrrwsz',
	data() {
		return {
			userType: sessionStorage.getItem("userType"),
      loading: false,
      rwlxList:[],
      mrrwszList:[],
      activeName: '',
      ywList: []
		}
	},
  components:{},
	created() {
    this.findYwList();
	},
	methods: {
    // 获取业务列表
    findYwList(){
        this.$post("admin/YwController/list", {zt: '1'}).then(rep =>{
            if(rep.code == '1'){
                this.ywList = rep.result.list;
                if(this.ywList.length > 0){
                    this.activeName = this.ywList[0].ywcode;
                    this.findRwlxList();
                }
            }
        })
    },
    handleClick(tab, event) {
        this.findRwlxList();
    },
    // 获取任务类型数据
    findRwlxList() {
      var _this = this;
      _this.$post("sys/findSysDictList", { dictType: "G", dictGroup: "103" }).then(rep => {
        if (rep.code == 1) {
          _this.rwlxList = rep.result.dictionaryList;
          _this.findXxlxList();
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 获取学习类型数据
    findXxlxList() {
      var _this = this;
      _this.$post("sys/findSysDictList", { dictType: "G", dictGroup: "102" }).then(rep => {
        if (rep.code == 1) {
          var xxlxList = rep.result.dictionaryList;
          _this.mrrwszList = []; // Initialize to empty before pushing
          for(var i=0;i<_this.rwlxList.length;i++){
            for(var j=0;j<xxlxList.length;j++){
              _this.mrrwszList.push({
                id:'',
                ywcode: _this.activeName,
                rwlx:_this.rwlxList[i].dictCode,
                rwlxmc:_this.rwlxList[i].dictName,
                dm:xxlxList[j].dictCode,
                mc:xxlxList[j].dictName,
                zhi:'',
                dw:'min'
              })
            }
          }
          _this.findMrrwszList();
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 获取数据
    findMrrwszList() {
      var _this = this;
      var params = {
        ywcode: _this.activeName
      }
      _this.loading = true;
      _this.$post("admin/ShezhiController/mrrwszList", params).then(rep => {
        _this.loading = false;
        if (rep.code == 1) {
          var mrrwszList = rep.result.list;
         if(mrrwszList.length>0){
           // Use map to create a lookup or just iterate and update existing _this.mrrwszList
           // Since _this.mrrwszList is initialized with all combinations, we should match and update values
           // But the original logic cleared _this.mrrwszList and pushed from rep.result.list
           // This means if rep.result.list is partial, we lose the other combinations?
           // Original logic:
           // _this.mrrwszList = [];
           // for ... push ...
           
           // If the backend returns ALL configurations for this business (which it should if saved), then replacing is fine.
           // But if it's the first time for a business, backend returns empty.
           // If backend returns empty, we keep the initialized list from findXxlxList.
           // If backend returns list, we replace?
           
           // Wait, the original code initialized mrrwszList in findXxlxList, then called findMrrwszList.
           // In findMrrwszList: if(mrrwszList.length>0) { _this.mrrwszList = []; ... push ... }
           // So if backend has data, it replaces the initialized list. This assumes backend data is complete.
           
           _this.mrrwszList = [];
           for (var i=0;i<mrrwszList.length;i++){
             var dw = mrrwszList[i].dw;
             if(dw==='s'){
               mrrwszList[i].dw = 'min';
               mrrwszList[i].zhi = mrrwszList[i].zhi/60;
             }
             _this.mrrwszList.push(mrrwszList[i]);
           }
         }
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    mrrwszSave(){
      var _this = this;
      //判断mrrwszList中的值是否负数
      for(var i=0;i<_this.mrrwszList.length;i++){
        if(_this.mrrwszList[i].zhi===''||_this.mrrwszList[i].zhi==null||_this.mrrwszList[i].zhi==undefined||_this.mrrwszList[i].zhi==0){
          _this.$message({
            type: "error",
            message: _this.mrrwszList[i].mc+'不能为空或者不能为0'
          });
          return;
        }
        if(_this.mrrwszList[i].zhi<0){
          _this.$message({
            type: "error",
            message: _this.mrrwszList[i].mc+'请输入非负数'
          });
          return;
        }
      }
      _this.$confirm('是否确认设置', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const processedList = this.mrrwszList.map(item => {
          // 创建新对象保持数据不可变
          const newItem = { ...item };
          if(!newItem.ywcode) newItem.ywcode = this.activeName;
          if (newItem.dw === 'min') {
            newItem.zhi = newItem.zhi * 60;  // 修复原代码中的数组索引错误
            newItem.dw = 's';
          }
          return newItem;
        });
        this.$post("admin/ShezhiController/mrrwszSave", processedList ,'json').then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: '设置成功'
            });
            this.rwlxList=[];
            this.mrrwszList=[];
            this.findRwlxList();
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    }
	},
}
</script>

<style lang="less">
.school-manage {
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}
}
</style>
